import { SELECT_OPTION_TYPE } from './globals';

export enum UsState {
  ArmedForcesAmericas = 'AA',
  ArmedForcesEurope = 'AE',
  Alaska = 'AK',
  Alabama = 'AL',
  ArmedForcesPacific = 'AP',
  Arkansas = 'AR',
  AmericanSamoa = 'AS',
  Arizona = 'AZ',
  California = 'CA',
  Colorado = 'CO',
  Connecticut = 'CT',
  DistrictOfColumbia = 'DC',
  Delaware = 'DE',
  Florida = 'FL',
  FederatedStatesOfMicronesia = 'FM',
  Georgia = 'GA',
  Guam = 'GU',
  Hawaii = 'HI',
  Iowa = 'IA',
  Idaho = 'ID',
  Illinois = 'IL',
  Indiana = 'IN',
  Kansas = 'KS',
  Kentucky = 'KY',
  Louisiana = 'LA',
  Massachusetts = 'MA',
  Maryland = 'MD',
  Maine = 'ME',
  MarshallIslands = 'MH',
  Michigan = 'MI',
  Minnesota = 'MN',
  Missouri = 'MO',
  NorthernMarianaIslands = 'MP',
  Mississippi = 'MS',
  Montana = 'MT',
  NorthCarolina = 'NC',
  NorthDakota = 'ND',
  Nebraska = 'NE',
  NewHampshire = 'NH',
  NewJersey = 'NJ',
  NewMexico = 'NM',
  Nevada = 'NV',
  NewYork = 'NY',
  Ohio = 'OH',
  Oklahoma = 'OK',
  Oregon = 'OR',
  Pennsylvania = 'PA',
  PuertoRico = 'PR',
  Palau = 'PW',
  RhodeIsland = 'RI',
  SouthCarolina = 'SC',
  SouthDakota = 'SD',
  Tennessee = 'TN',
  Texas = 'TX',
  Utah = 'UT',
  Virginia = 'VA',
  VirginIslands = 'VI',
  Vermont = 'VT',
  Washington = 'WA',
  Wisconsin = 'WI',
  WestVirginia = 'WV',
  Wyoming = 'WY',
}

export const US_STATE_NAMES: Record<UsState, string> = {
  [UsState.ArmedForcesAmericas]: 'Armed Forces Americas',
  [UsState.ArmedForcesEurope]: 'Armed Forces Europe',
  [UsState.Alaska]: 'Alaska',
  [UsState.Alabama]: 'Alabama',
  [UsState.ArmedForcesPacific]: 'Armed Forces Pacific',
  [UsState.Arkansas]: 'Arkansas',
  [UsState.AmericanSamoa]: 'American Samoa',
  [UsState.Arizona]: 'Arizona',
  [UsState.California]: 'California',
  [UsState.Colorado]: 'Colorado',
  [UsState.Connecticut]: 'Connecticut',
  [UsState.DistrictOfColumbia]: 'District of Columbia',
  [UsState.Delaware]: 'Delaware',
  [UsState.Florida]: 'Florida',
  [UsState.FederatedStatesOfMicronesia]: 'Federated States of Micronesia',
  [UsState.Georgia]: 'Georgia',
  [UsState.Guam]: 'Guam',
  [UsState.Hawaii]: 'Hawaii',
  [UsState.Iowa]: 'Iowa',
  [UsState.Idaho]: 'Idaho',
  [UsState.Illinois]: 'Illinois',
  [UsState.Indiana]: 'Indiana',
  [UsState.Kansas]: 'Kansas',
  [UsState.Kentucky]: 'Kentucky',
  [UsState.Louisiana]: 'Louisiana',
  [UsState.Massachusetts]: 'Massachusetts',
  [UsState.Maryland]: 'Maryland',
  [UsState.Maine]: 'Maine',
  [UsState.MarshallIslands]: 'Marshall Islands',
  [UsState.Michigan]: 'Michigan',
  [UsState.Minnesota]: 'Minnesota',
  [UsState.Missouri]: 'Missouri',
  [UsState.NorthernMarianaIslands]: 'Northern Mariana Islands',
  [UsState.Mississippi]: 'Mississippi',
  [UsState.Montana]: 'Montana',
  [UsState.NorthCarolina]: 'North Carolina',
  [UsState.NorthDakota]: 'North Dakota',
  [UsState.Nebraska]: 'Nebraska',
  [UsState.NewHampshire]: 'New Hampshire',
  [UsState.NewJersey]: 'New Jersey',
  [UsState.NewMexico]: 'New Mexico',
  [UsState.Nevada]: 'Nevada',
  [UsState.NewYork]: 'New York',
  [UsState.Ohio]: 'Ohio',
  [UsState.Oklahoma]: 'Oklahoma',
  [UsState.Oregon]: 'Oregon',
  [UsState.Pennsylvania]: 'Pennsylvania',
  [UsState.PuertoRico]: 'Puerto Rico',
  [UsState.Palau]: 'Palau',
  [UsState.RhodeIsland]: 'Rhode Island',
  [UsState.SouthCarolina]: 'South Carolina',
  [UsState.SouthDakota]: 'South Dakota',
  [UsState.Tennessee]: 'Tennessee',
  [UsState.Texas]: 'Texas',
  [UsState.Utah]: 'Utah',
  [UsState.Virginia]: 'Virginia',
  [UsState.VirginIslands]: 'U.S. Virgin Islands',
  [UsState.Vermont]: 'Vermont',
  [UsState.Washington]: 'Washington',
  [UsState.Wisconsin]: 'Wisconsin',
  [UsState.WestVirginia]: 'West Virginia',
  [UsState.Wyoming]: 'Wyoming',
};

export const USStatesAndTerritories = Object.entries(US_STATE_NAMES)
  .filter(
    ([value]) =>
      value !== UsState.ArmedForcesAmericas &&
      value !== UsState.ArmedForcesEurope &&
      value !== UsState.ArmedForcesPacific
  )
  .map(([value, text]) => ({ text, value: value as UsState }))
  .sort((a, b) => a.text.localeCompare(b.text));

const nameOrCode = (state: string) => {
  return US_STATE_NAMES[state as UsState] || state;
};

export const STATES = Object.values(UsState).map(value => ({ text: value, value }));

export const STATES_PRETTY = STATES.map(
  o =>
    ({
      text: nameOrCode(o.text),
      value: o.value,
    }) as SELECT_OPTION_TYPE
).sort((a, b) => a.text.localeCompare(b.text));

export const CANADIAN_PROVINCES = [
  { text: 'AB', value: 'AB' },
  { text: 'BC', value: 'BC' },
  { text: 'MB', value: 'MB' },
  { text: 'NB', value: 'NB' },
  { text: 'NL', value: 'NL' },
  { text: 'NT', value: 'NT' },
  { text: 'NS', value: 'NS' },
  { text: 'NU', value: 'NU' },
  { text: 'ON', value: 'ON' },
  { text: 'PE', value: 'PE' },
  { text: 'QC', value: 'QC' },
  { text: 'SK', value: 'SK' },
  { text: 'YT', value: 'YT' },
];
